function normalizeBaseUrl(raw) {
  if (raw == null) return null;
  const s = String(raw).trim();
  if (s === "" || s === "undefined") return null;
  return s.endsWith("/") ? s : `${s}/`;
}

const fromEnv = normalizeBaseUrl(process.env.REACT_APP_BASE_URL);

const fallback = undefined;

export const apiBaseUrl = fromEnv ?? fallback;

if (!fromEnv && typeof console !== "undefined") {
  console.log(
    "已使用預設後端 URL：為設定",
    apiBaseUrl,
    "請在建置變數中設定"
  );
}
